import { makeVar } from '@apollo/client'

type ConfirmDialog = {
  key: string
  title: string
  message: string
  confirmButtonText: string
  confirmIsDanger?: true
  cancelButtonText: string
  onConfirm: () => void
  onCancel?: () => void
}

export const confirmDialogVar = makeVar<ConfirmDialog[]>([])
